import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import { HsRegularGeometryData } from '../geometry-utils/regular-geometry-data.class';

export function hsGenerateCylinderGeometryData(
  quality: number = 12,
  upperCap: boolean = true,
  bottomCap: boolean = true
): HsRegularGeometryData {
  const up: number = 1;
  const down: number = -1;
  const vertices: number[] = [];
  const normals: number[] = [];
  const capVertices: number[] = [];
  const capNormals: number[] = [];
  for (let i: number = 0; i < quality; i++) {
    const angle0: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
    const angle1: number = ((i + 1) / quality) * HsHypersceneConstants.PI_MUL_2;
    const x0: number = Math.cos(angle0);
    const x1: number = Math.cos(angle1);
    const z0: number = Math.sin(angle0);
    const z1: number = Math.sin(angle1);
    vertices.push(x0, down, z0, x1, down, z1, x1, up, z1);
    vertices.push(x0, down, z0, x1, up, z1, x0, up, z0);
    normals.push(x0, 0, z0, x1, 0, z1, x1, 0, z1);
    normals.push(x0, 0, z0, x1, 0, z1, x0, 0, z0);
  }
  if (upperCap) {
    for (let i: number = 0; i < quality; i++) {
      const angle0: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
      const angle1: number = ((i + 1) / quality) * HsHypersceneConstants.PI_MUL_2;
      const x0: number = Math.cos(angle0);
      const x1: number = Math.cos(angle1);
      const z0: number = Math.sin(angle0);
      const z1: number = Math.sin(angle1);
      capVertices.push(x0, up, z0, x1, up, z1, 0, up, 0);
      capNormals.push(0, up, 0, 0, up, 0, 0, up, 0);
    }
  }
  if (bottomCap) {
    for (let i: number = 0; i < quality; i++) {
      const angle0: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
      const angle1: number = ((i + 1) / quality) * HsHypersceneConstants.PI_MUL_2;
      const x0: number = Math.cos(angle0);
      const x1: number = Math.cos(angle1);
      const z0: number = Math.sin(angle0);
      const z1: number = Math.sin(angle1);
      capVertices.push(x1, down, z1, x0, down, z0, 0, down, 0);
      capNormals.push(0, down, 0, 0, down, 0, 0, down, 0);
    }
  }
  vertices.push(...capVertices);
  normals.push(...capNormals);
  return new HsRegularGeometryData(vertices, normals);
}
